module.exports = __webpack_public_path__ + "img/EN.b2a33caf.svg";